import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination } from "../common";
import './Updates.css';

const Updates_3_54_0 = () => {
  return (
    <div>
      <PageTitle title='3.54.0' />

      <ParaTitle paraTitle='Table Updates' />
      <Paragraph paragraph='2026-09-02' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Add Export Buttons to Datatables
          <p>
            Enhance DataTables by adding export options that allow users to:
            <p>- Export table data;</p>
            <p>- Select and export entire columns.</p>
            This will provide users with greater flexibility in retrieving and working with table data.
          </p>
        </li>
        <li>
          Reviewer Activity Report
          <p>
            Develop a report to track how long reviewers take to move events through each stage of the review process. This will help identify delayed responses, bottlenecks, and users who consistently take longer than expected to complete their reviews.

          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>
          PDF Style Updates
          <p>
            Update the PDF report styling to improve its professional appearance, consistency, and print efficiency. Create a more professional and consistent report layout while minimizing ink usage when printing.
          </p>
        </li>

        <li>
          Verify Periodic Notification Emails Are Working
          <p>
            Verify that automated reminder emails are functioning as expected, including:
            <p>Ensure reminder emails are sent when users take too long to review an event or complete an approval;</p>
            <p>Verify that weekly summary reports are being sent out correctly.</p>
            Provide timely reminders to help users stay on top of pending reviews and approvals.
          </p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.55.0', link: '/updates/3.55.0' },
          next: { name: 'Updates: 3.53.0', link: '/updates/3.53.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_54_0;